// ja strings for messages/checkout.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const checkout: Dict = {
  "checkout.declined":
    "カードが承認されませんでした。カード会社にお問い合わせいただくか、別のお支払い方法をお試しください。",
  "checkout.trialStarted": "無料トライアルが始まりました！",
  "checkout.thanks": "ご購入ありがとうございます！",
  "checkout.startTrial": "無料トライアルを開始",
  "checkout.pay": "支払う",
};

export default checkout;
